import React, { Component, api } from "react";
import "./index.scss";
import VoiceControl from "@/components/voiceControl";
import HospitalList from "@/components/hospitalList";
import { connect } from "react-redux";
import { storeChangeObject } from "@action";
import { config, srcPath } from "@utils/config";
import { recordEven } from "@/api/actions";
import vUtil from "@utils/vUtil.min";
class Result extends Component {
  state = {
    isShowSave: false,
    isShowHospital: false,
    isShowAbout: false,
    codeUrl: ""
  };
  onCloseBtn() {
    this.setState({
      isShowHospital: false
    });
    audioBtn.play();
    recordEven("关闭咨询HIV");
  }
  restartToHome() {
    recordEven("返回首页");
    audioBtn.play();
    this.props.dispatch(
      storeChangeObject({
        pageTag: "home",
        videoSrc: srcPath[config[0].path],
        videoData: config[0],
        videoSpeed: 1,
        homeType: "result"
      })
    );
  }
  componentDidMount() {
    myVideo.style.display = "none";
    api("GETQRCODR", {
      sourceCode: vUtil.Location.search("source") || "直接访问"
    }).then(res => {
      console.log(res);
      if (res) {
        this.setState({
          codeUrl: "http://hivcampaign.gileadchina.cn" + res
        });
      }
    });
  }
  componentWillUnmount() {
    myVideo.style.display = "block";
  }
  saveImgFn() {
    recordEven("保存页面");
    audioBtn.play();
    if (vUtil.UA.pc) {
      var alink = document.createElement("a");
      alink.href = require("@img/save_img.jpg");
      alink.download = "HIV"; //图片名
      alink.click();
    } else {
      this.setState({
        isShowSave: true
      });
      setTimeout(
        () =>
          this.setState({
            isShowSave: false
          }),
        1000
      );
    }
  }
  render() {
    const { state } = this;
    return (
      <div className="home_bg ov">
        {/* 声音控制 */}
        <VoiceControl />
        <img
          src={require("@img/save_img.jpg")}
          className="wh100"
          style={{ opacity: 0 }}
        ></img>
        <div className="result_btn_box">
          <div className="result_btn" onClick={this.restartToHome.bind(this)}>
            <img src={require("@img/btn_bg.png")} className="btn_bg"></img>
            <div className="result_btn_txt cen poa wh100 dis_f ali_ct jus_ct fle_t">
              重新
              <br />
              开始
            </div>
          </div>
          <div className="result_btn" onClick={this.saveImgFn.bind(this)}>
            <img src={require("@img/btn_bg.png")} className="btn_bg"></img>
            <div className="result_btn_txt cen poa wh100 dis_f ali_ct jus_ct fle_t">
              保存
              <br />
              页面
            </div>
          </div>
          <div
            className="result_btn"
            onClick={() => {
              this.setState({
                isShowHospital: true
              });
              recordEven("咨询HIV");
              audioBtn.play();
            }}
          >
            <img src={require("@img/btn_bg.png")} className="btn_bg"></img>
            <div className="result_btn_txt cen poa wh100 dis_f ali_ct jus_ct fle_t">
              检测
              <br />
              咨询
            </div>
          </div>
          <div
            className="result_btn"
            onClick={() => {
              this.setState({
                isShowAbout: true
              });
              recordEven("了解吉利德");
              audioBtn.play();
            }}
          >
            <img src={require("@img/btn_bg.png")} className="btn_bg"></img>
            <div className="result_btn_txt cen poa wh100 dis_f ali_ct jus_ct fle_t">
              了解
              <br />
              吉利德
            </div>
          </div>
        </div>
        {/* 保存页面 */}
        {this.state.isShowSave && (
          <div className="save_page cen poa">长按背景图片保存</div>
        )}
        {/* 咨询HIV */}
        {this.state.isShowHospital && (
          <HospitalList onCloseBtn={this.onCloseBtn.bind(this)}></HospitalList>
        )}
        {/* 了解吉利 */}
        <div className={`toast_bg ${this.state.isShowAbout ? "" : " dis_n"}`}>
          <div className="about_box cen poa">
            <div className="about_top dis_f ali_ct jus_bt">
              <div className="top_txt">了解吉利德</div>
              <img
                onClick={() => {
                  this.setState({
                    isShowAbout: false
                  });
                  audioBtn.play();
                  recordEven("关闭了解吉利德");
                }}
                src={require("@img/close.png")}
                className="top_close"
              />
            </div>
            <div className="about_body dis_f fle_t ali_ct">
              <img
                src={state.codeUrl ? state.codeUrl : require("@img/QR.png")}
                onTouchStart={()=>recordEven("长按二维码")}
              />
              <p>
                {vUtil.UA.pc ? "扫描" : "长按"}二维码关注“吉利德科学”
                <br />
                微信公众号，了解HIV相关知识。
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, null)(Result);
